import { render, staticRenderFns } from "./SurveyFile.vue?vue&type=template&id=dbbaf844&scoped=true&"
import script from "./SurveyFile.vue?vue&type=script&lang=js&"
export * from "./SurveyFile.vue?vue&type=script&lang=js&"
import style0 from "./SurveyFile.vue?vue&type=style&index=0&id=dbbaf844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbaf844",
  null
  
)

export default component.exports